import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import { BootstrapVue3 } from "bootstrap-vue-3";

import { createRouter } from "@/router";
import { createStore } from "@/store";

const appContainer = document.getElementById("app");
const csrf = appContainer!.dataset.csrf;
let initObject = appContainer!.dataset.object;
if (initObject) {
  initObject = JSON.parse(initObject);
}

const router = createRouter(appContainer!);
const store = createStore();

const app = createApp(App, { csrf: csrf, initObject });
app.use(router);
app.use(BootstrapVue3);
app.use(store);
app.mount("#app");
